var React = require('react');

function CheckmarkDecorativeInline (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M42.0192 2.7931C39.5246 0.298485 35.2607 0.238331 32.943 2.55602C30.6253 4.87372 12.7136 22.7854 12.7136 22.7854L7.2644 17.4494C5.60132 15.7863 2.90855 15.7863 1.24548 17.4494C-0.4176 19.1125 -0.4176 21.8053 1.24548 23.4683L9.66348 31.8863C10.495 32.7179 11.5849 33.1319 12.6712 33.1319C13.7575 33.1319 14.8509 32.7179 15.6789 31.8863L37.4475 10.1248C40.2464 7.32587 42.9746 6.77741 45.9929 6.77387C45.9929 6.77387 42.1006 2.88156 42.0121 2.7931H42.0192Z","fill":"#4DCB2A"}));
}

CheckmarkDecorativeInline.defaultProps = {"width":"1em","height":"1em","viewBox":"0 0 46 34","fill":"none"};

module.exports = CheckmarkDecorativeInline;

CheckmarkDecorativeInline.default = CheckmarkDecorativeInline;
